/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineClassModulesQueryResponse,
  GetApiV1ClassroomdisciplineClassModulesQueryParams,
  GetApiV1ClassroomdisciplineClassModules401,
  GetApiV1ClassroomdisciplineClassModules500,
} from "../../types/classPlanningClassModuleController/GetApiV1ClassroomdisciplineClassModules.ts";

function getGetApiV1ClassroomdisciplineClassModulesUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/classroomdiscipline/class-modules` as const,
  };
  return res;
}

/**
 * @description Lista paginada de Módulos com filtros opcionais: CompanyId, Description (parcial), DateStart, DateFinish e ClassStudentId. **(Requer Authorization para autenticação)**
 * @summary Listar Módulos (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/class-modules}
 */
export async function getApiV1ClassroomdisciplineClassModules(
  params?: GetApiV1ClassroomdisciplineClassModulesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineClassModulesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineClassModules401
      | GetApiV1ClassroomdisciplineClassModules500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineClassModulesUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
